// extracted by mini-css-extract-plugin
export default {"table":"ViewProducts_table__nZ7lD","search":"ViewProducts_search__911-3","icons":"ViewProducts_icons__VAJEm"};